import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#ac1927',
        background: '#FFFFFF',
        themeBackground: '#fffcfc'
      },
      dark: {
        primary: '#ac1927',
        background: '#1E1E1E',
        themeBackground: '#151515'
      }
    }
  }
});
